/* Surgia: explicit Add to cart for single-variant collection cards. */
(() => {
  const counterSelector = '.surgia-editable-header__count';
  let lastCountRequest = 0;

  const setCount = (value) => {
    const count = Number(value);
    if (!Number.isFinite(count) || count < 0) return;
    document.querySelectorAll(counterSelector).forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
  };

  async function getCart() {
    const url = (typeof routes !== 'undefined' && routes.cart_url) || '/cart';
    const response = await fetch(url + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Cart could not be refreshed');
    return response.json();
  }

  async function syncCount(data) {
    if (data && typeof data.item_count === 'number') {
      ++lastCountRequest;
      setCount(data.item_count);
      return;
    }
    const req = ++lastCountRequest;
    const cart = await getCart();
    if (req === lastCountRequest) setCount(cart.item_count);
  }

  function updateSections(sections) {
    if (!sections) return;
    const parser = new DOMParser();
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const source = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (source) bubble.innerHTML = source.innerHTML;
    }
    const drawer = document.querySelector('cart-drawer');
    const inner = drawer?.querySelector('.drawer__inner');
    if (inner && sections['cart-drawer']) {
      const source = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('.drawer__inner');
      if (source) {
        inner.innerHTML = source.innerHTML;
        drawer.classList.toggle('is-empty', !source.querySelector('.cart-item'));
      }
    }
  }

  async function add(button) {
    const card = button.closest('.surgia-card-add');
    if (!card || button.disabled) return;
    // Add the variant's minimum permitted quantity; the card has one CTA only.
    const amount = Number(card.dataset.addQuantity || 1);
    if (!Number.isInteger(amount) || amount < 1) return;
    const message = card.querySelector('.surgia-card-add__message');
    const label = button.querySelector('span');
    const original = label?.textContent || 'Add to cart';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding…';
    if (message) { message.classList.add('visually-hidden'); message.textContent = ''; }
    try {
      const url = (typeof routes !== 'undefined' && routes.cart_add_url) || '/cart/add.js';
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(card.dataset.variantId), quantity: amount }],
          sections: ['cart-icon-bubble', 'cart-drawer'],
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'Unable to add to cart');
      updateSections(data.sections);
      const sectionHTML = data.sections?.['cart-icon-bubble'];
      if (sectionHTML) {
        const parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
        const countText = parsed.querySelector('.cart-count-bubble span[aria-hidden="true"]')?.textContent?.trim();
        if (countText && /^\d+$/.test(countText)) setCount(Number(countText));
      }
      const cart = await getCart();
      await syncCount(cart);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'surgia-card-add', cartData: cart });
      }
      if (message) message.textContent = 'Added to cart';
    } catch (error) {
      if (message) {
        message.classList.remove('visually-hidden');
        message.textContent = error.message || 'Unable to add to cart. Please try again.';
      }
    } finally {
      if (label) label.textContent = original;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.surgia-card-add__button');
    if (button) add(button);
  });

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      syncCount(event?.cartData).catch((error) => console.warn('[Surgia] Cart badge update failed', error));
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else init();
})();
